import { db } from "../Config";
import { CPrestacion } from "../../../Entidades/Prestaciones";

const getPrestacionesCollection = (pacienteId, empresaId) => {
  return db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("prestaciones");
};

export const fetchPrestacionesTerminadas = async (pacienteId, empresaId) => {
  let prestaciones = [];
  await getPrestacionesCollection(pacienteId, empresaId)
    .where("estado", "in", ["TERMINADO", "ACTIVO", "TERMICAN"])
    .orderBy("fechaFin", "desc")
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        prestaciones.push({
          id: doc.id,
          tratamiento: doc.data().tratamiento,
          precio: doc.data().precio,
          dientes: doc.data().dientes,
          pagado: doc.data().pagado,
          estado: doc.data().estado,
          caras: doc.data().caras,
          pacienteId: doc.data().pacienteId,
          fechaFin: doc.data().fechaFin,
          notasClinicas: doc.data().notasClinicas,
          tipo: doc.data().tipo,
          tiempo: doc.data().tiempo !== undefined ? Number(doc.data().tiempo) : 30,
        });
      });
    })
    .catch((err) => {
      throw new Error(err);
    });
  return prestaciones;
};

export const fetchAllPrestacionesHistory = async (pacienteId, empresaId) => {
  let prestaciones = [];
  await getPrestacionesCollection(pacienteId, empresaId)
    .where("estado", "in", ["TERMINADO", "ACTIVO", "TERMICAN", "PENDIENTE"]) // Added PENDIENTE
    .orderBy("fechaFin", "desc")
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        prestaciones.push({
          id: doc.id,
          tratamiento: doc.data().tratamiento,
          precio: doc.data().precio,
          dientes: doc.data().dientes,
          pagado: doc.data().pagado,
          estado: doc.data().estado,
          caras: doc.data().caras,
          pacienteId: doc.data().pacienteId,
          fechaFin: doc.data().fechaFin,
          notasClinicas: doc.data().notasClinicas,
          tipo: doc.data().tipo,
          config: doc.data().config, // Important for grouping/display
          tiempo: doc.data().tiempo !== undefined ? Number(doc.data().tiempo) : 30,
        });
      });
    })
    .catch((err) => {
      throw new Error(err);
    });
  return prestaciones;
};

export const getPrestacion = (prestacionId, pacienteId, empresaId) => {
  let prestacion;
  return new Promise((resolve, reject) => {
    let prestacionRef = getPrestacionesCollection(pacienteId, empresaId).doc(prestacionId);
    prestacionRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          prestacion = {
            id: doc.id,
            tratamiento: doc.data().tratamiento,
            tipo: doc.data().tipo,
            precio: Number(doc.data().precio),
            dientes: doc.data().dientes,
            pagado: Number(doc.data().pagado),
            estado: doc.data().estado,
            estfin: doc.data().estfin,
            caras: doc.data().caras,
            pacienteId: doc.data().pacienteId,
            notasClinicas: doc.data().notasClinicas,
            config: doc.data().config,
            lab: doc.data().lab,
            tratamientoId: doc.data().tratamientoId,
            tiempo: doc.data().tiempo !== undefined ? Number(doc.data().tiempo) : 30,
          };
        } else {
          prestacion = new CPrestacion();
        }
        resolve(prestacion);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const fetchPrestacionesTerminadasEmpresa = async (empresaId, fecha) => {
  let prestaciones = [];
  // Usamos collectionGroup para reportes transversales
  await db
    .collectionGroup("prestaciones")
    .where("estado", "in", ["TERMINADO"])
    .where("empresaId", "==", empresaId)
    .where("fechaFin", ">=", fecha)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        prestaciones.push({
          id: doc.id,
          tratamiento: doc.data().tratamiento,
          precio: doc.data().precio,
          dientes: doc.data().dientes,
          pagado: doc.data().pagado,
          estado: doc.data().estado,
          caras: doc.data().caras,
          pacienteId: doc.data().pacienteId,
          fechaFin: doc.data().fechaFin,
          notasClinicas: doc.data().notasClinicas,
        });
      });
    })
    .catch((err) => {
      throw new Error(err);
    });
  return prestaciones.length;
};

export const getPrestacionesCountByEmpresaMonth = async (currentDate, empresaId) => {
  if (!empresaId || !currentDate) return 0;
  // Get first and last day of current month
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0, 23, 59, 59, 999);
  try {
    // Usamos collectionGroup para reportes transversales
    const snapshot = await db.collectionGroup('prestaciones')
      .where('empresaId', '==', empresaId)
      .where('fechaInicio', '>=', firstDay)
      .where('fechaInicio', '<=', lastDay)
      .get();
    return snapshot.size;
  } catch (error) {
    console.error('Error getting prestaciones count:', error);
    return 0;
  }
};
